import { useEffect } from 'react';
import { isEmpty } from 'lodash';

const useErrorForMissingImageProps = (imageParams, images, resolutionsByBreakpoint) => {
  useEffect(() => {
    if (resolutionsByBreakpoint !== null && resolutionsByBreakpoint !== void 0 ? resolutionsByBreakpoint : !isEmpty(imageParams)) {
      return;
    }

    if (process.env.NODE_ENV !== 'production') {
      if (!(imageParams === null || imageParams === void 0 ? void 0 : imageParams.imageSrc) && !images) {
        throw new Error('Missing required prop. Either of `src` or `images` is required.');
      } else if ((imageParams === null || imageParams === void 0 ? void 0 : imageParams.imageSrc) && !images && !(imageParams === null || imageParams === void 0 ? void 0 : imageParams.imageHeight) && !(imageParams === null || imageParams === void 0 ? void 0 : imageParams.imageWidth)) {
        throw new Error('Missing required prop. Either of `baseResolutionHeight` or `height` or `baseResolutionWidth` or `width` is required.');
      }
    }
  }, [imageParams, images, resolutionsByBreakpoint]);
};

export { useErrorForMissingImageProps };
